(function() {
    $(document).ready(function() {
        const section = $('.mod24NextBestAction');
        const boxWrap = $('.box24Wrap', section);

        if (section.length > 0) {
            $.getJSON(window.c24LpRoot + 'api/?k=24&a=nextbestactions', function(json) {
                if (json.success && json.items.length > 0) {
                    $.each(json.items, function() {
                        boxWrap.append($('<div class="box24Item">' + this + '</div>'));
                    });

                    if (json.items.length < 4) {
                        $('.c24Carousel', section).removeClass('swipeable');
                        $('.c24Carousel .box24Nav.box24Prev', section).remove();
                        $('.c24Carousel .box24Nav.box24Next', section).remove();
                    }

                    $('.loading', section).hide();
                    $('.loaded', section).show();
                } else {
                    section.closest('.c24-cnt-ele').hide();

                    // hot fix vss teaser margin to following headline
                    section.closest('.c24-cnt-ele').prev().css({
                        'margin-bottom': '',
                    })
                        .addClass('keepMargin');
                }
            });
        }

        $('.mod24NextBestAction').on('click', 'article .close', function(e) {
            e.preventDefault();
            const closeAction = $(this);
            const id = closeAction.data('id');
            const section = closeAction.closest('.mod24NextBestAction');
            closeAction.closest('.box24Item').remove();
            if ($('.box24Item', section).length === 0) {
                section.closest('.c24-cnt-ele').stop().slideUp('fast');

                // hot fix vss teaser margin to following headline
                section.closest('.c24-cnt-ele').prev().css({
                    'margin-bottom': '',
                })
                    .addClass('keepMargin');
            }
            $.get(window.c24LpRoot + 'api/?k=24&a=nextbestactionsclose&q=' + id);
        });
    });
})();
